const ErrorMessage = ({ message, show }) => {
  if (!show) return null;

  return (
    <div className="text-red text-sm md:text-[0.875rem] mt-1 md:mt-1.5 font-medium leading-[1.4] text-center animate-fade-in-error">
      {message}
    </div>
  );
};

export default ErrorMessage;
